import React from 'react';
import InlineSVG from 'svg-inline-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../../button/Button';
import info from '../../../assets/images/info.svg';

const InfoIcon = ({ onClickHandler }) => (
    <Button onClick={onClickHandler} cssClasses={classNames('dashboard-info-icon')}>
        <InlineSVG src={info} />
    </Button>
);

InfoIcon.propTypes = {
    onClickHandler: PropTypes.func,
};

InfoIcon.defaultProps = {
    onClickHandler: undefined,
};

export default InfoIcon;
